import React from 'react';
import uuid from 'uuid/v4';
import {Root} from 'react-dom/client';
import {getServerTexts} from './../ReportGenerator/texts';
import {CustomQueryClientProvider} from '../../hooks/useQueryClientProvider';
import {AnalyticsReportsDialog} from './ReportsDialog/ReportsDialog';

export async function renderAnalyticsReportsDialog(root: Root, props) {
    await getServerTexts();

    root.render(
        <CustomQueryClientProvider>
            <AnalyticsReportsDialog {...props} key={uuid()} />
        </CustomQueryClientProvider>
    );
}
